import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';
import { useIntl } from 'react-intl';

import { noop } from '../../../default-props/noop';
import { Button } from '../../button';
import { generateDataTestidAttribute } from '../../../services/testid-service';

import { useModalContext } from '../context';
import { messages } from '../messages';
import style from './modal-close-button.module.less';

export const ModalCloseButton = ({ closeModal = noop, className = '' }) => {
  const { onCancel, onClose } = useModalContext();
  const intl = useIntl();

  const onClick = useCallback(() => {
    const isCancel = true;
    if (onCancel) {
      onCancel();
    } else if (onClose) {
      onClose(isCancel);
    } else {
      closeModal(isCancel);
    }
  }, [closeModal, onCancel, onClose]);

  return (
    <Button
      {...generateDataTestidAttribute('close-button')}
      buttonTitle={intl.formatMessage(messages.modalClose)}
      className={classnames(className, style['modal-close-button'])}
      onClick={onClick}
      theme='unstyled'
    >
      <FontAwesomeIcon icon={faTimes} />
    </Button>
  );
};

ModalCloseButton.propTypes = {
  closeModal: PropTypes.func,
  className: PropTypes.string,
};
